import { render, staticRenderFns } from "./createFilial.vue?vue&type=template&id=68cb2c22&scoped=true&"
import script from "./createFilial.vue?vue&type=script&lang=js&"
export * from "./createFilial.vue?vue&type=script&lang=js&"
import style0 from "./createFilial.vue?vue&type=style&index=0&id=68cb2c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb2c22",
  null
  
)

export default component.exports